<app-nav-bar></app-nav-bar>

<section id="new-thrift">
    <button class="back-btn" (click)="back()" ><i class="fa fa-backward"><span> BACK</span></i></button>
    
    <div class="container">
        
        <div class="thrift-form">
            <h3>Create Thrift <small>Fill in all required details</small></h3>
            <form  [formGroup]="createThrift">
              <fieldset>
                <legend>Thrift Name</legend>
                <input type="text"
                id="thriftName"
                formControlName="thriftName"
                name="thriftname"
                required>
              </fieldset>

              <fieldset>
                <legend>Thrift Type</legend>
                <select [(ngModel)]="thriftType" name="thrifttype" (change)="changeThriftType($event.target)" id="thriftType" >
                  <option value="Personal">Personal</option>
                  <option value="Corporate">Corporate</option>
                </select>
              </fieldset>
               
              <fieldset>
                <legend>Contribution Amount (₦)</legend>
                <input type="number"
              id="amount"
              min="2"
              formControlName="amount"
              name="amount"
              required>
              </fieldset>
              
              <fieldset>
                <legend>Description</legend>
                <textarea id="description" formControlName="description" name="description"  cols="20" rows="10"></textarea>
              </fieldset>
            
              <fieldset>
                <legend>Number of People</legend>
                <input type="number"
                id="users"
                formControlName="users"
               name="users"
                min="2"
                required>
                
              </fieldset>

              <fieldset>
                <legend>Specify Amount Locked in User Account (₦)</legend>
                <input type="number"
                id="lockFunds"
                formControlName="lockFunds"
               name="lockFuds"
                min="0"
                required>
                
              </fieldset>
             
              <fieldset>
                <legend>Choose Schedule</legend>
                <select [(ngModel)]="schedule" name="schedule" formControlName="schedules"  id="schedule" >
                  
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                </select>
              </fieldset>

              <div [hidden]="thriftType == 'personal'" >
                <fieldset>
                  <legend> Invite via Email <small>(seperate emails with comma)</small></legend>
                  <textarea id="emails" formControlName="emails" name="email"  cols="20" rows="10"></textarea>
                </fieldset>
              </div>
              

              <button [disabled]="createThrift.invalid">Create Thrift</button>
            
            </form>
        </div>
    </div>

</section>